export const replacePath = (path: string) => {
  const [basePath] = path.split('?');
  const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
  return basePath.replaceAll(uuidRegex, '?');
};
